import { ChangeDetectorRef, Component } from '@angular/core';
import { ContactPicklistComponent } from '../contact-picklist/contact-picklist.component';
import { Subscription, catchError, concat, debounceTime, distinctUntilChanged, filter, of, switchMap, tap } from 'rxjs';
import { ContactModel } from 'src/app/core/models/contact/contact.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { ContactListService } from 'src/app/core/services/list-services/contact-list.service';
import { ContactModalService } from 'src/app/core/services/modal-services/contact-modal.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { ContactViewModalService } from 'src/app/core/services/modal-services/contact-view-module.service';
import { ContactBaseModel } from 'src/app/core/models/contact/contact-base.model';
import { ContactSearchModal } from 'src/app/core/models/contact/contacts-search.model';
import { SearchResultModel } from 'src/app/core/models/query/search-result-model';
import { TaskModalService } from 'src/app/core/services/modal-services/task-modal.service';
import { TableConfigService } from 'src/app/core/services/table-config.service';

@Component({
  selector: 'app-contact-list-dropdown',
  templateUrl: './contact-list-dropdown.component.html',
  styleUrls: ['./contact-list-dropdown.component.scss']
})
export class ContactListDropdownComponent extends ContactPicklistComponent {

  selectedModelsArray: any[] = [];

  constructor(
    protected myContactModalService: ContactModalService,
    private myContactPicklistService: ContactViewModalService,
    protected override taskModalService: TaskModalService,
    protected override changeDetectorRef: ChangeDetectorRef,
    protected override contactListService: ContactListService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override tableConfigService: TableConfigService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override openModalService: OpenModalService,
  ) {
    super(changeDetectorRef, taskModalService, contactListService, toasterNotificationService, tableConfigService,myFileApiService, sanitizer, openModalService, pdfModalService, authMyFileService);
  }

  override ngOnInit(): void {

    this.listItemsObservable = this.contactListService.resultItems$;
    this.total = this.contactListService.total$;
    this.isLoading = this.contactListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
    });
    this.unsubscribe.push(subscr2);

    this.changeDetectorRef.detectChanges();

    this.loadModelsInDropDownList();
    if (this.referenceModel.id) {
      this.selectedModelsArray.push(this.referenceModel)
    }
  }

  getDropdownName(item: any) {
    if (item.firstName && item.firstName != '' && item.companyName && item.companyName != '') {
      return `${item.fullName} - ${item.companyName}`;
    } else {
      return `${item.fullName}`;
    }
  }

  /**
   * Opens a new Modal.
   * @param modal used for a modal type using enum in the model-contactListService.contactListServices.ts
   * @param model a model which will be passed to the modal
   */
  openPicklistModal(model: any) {
    if (this.disabled !== true) {
      this.myContactPicklistService.openModal(model);
      var sub: Subscription = this.myContactPicklistService.modelChanged.subscribe((result: ContactModel) => {
        if (result) {
          this.model = new ContactModel();
          this.model = { ...this.model, ...result };
          this.legacyContactInfoCheckAndSet();
          this.referenceModel = this.model;
          this.selectedModelsArray = [];
          this.selectedModelsArray.push(result);
          this.referenceModelChange.emit(this.referenceModel);
        }
        this.submitted = false;
        sub.unsubscribe();
      });
    }
  }

  openModalNewContactDropDownSearch() {
    if (this.disabled !== true) {
      this.myContactModalService.openModal();
      var sub: Subscription = this.myContactModalService.modelChanged.subscribe((contact: any) => {
        if (contact.id) {
          this.model = contact;
          this.legacyContactInfoCheckAndSet();
          this.referenceModel = this.model;
          this.selectedModelsArray = [];
          this.selectedModelsArray.push(this.model);
          this.referenceModelChange.emit(this.referenceModel);
        }
        sub.unsubscribe();
      })
    }
  }

  loadModelsInDropDownList() {
    this.listItems$ = concat(
      of([]), // default items
      this.listItemsInput$.pipe(
        filter(res => {
          if (res !== null && res.length > this.minLengthTerm) {
            this.searchTermLength = res.length;
          } else {
            this.searchTermLength = 0;
          }
          return res !== null && res.length > this.minLengthTerm;
        }),
        distinctUntilChanged(),
        debounceTime(800),
        tap(() => this.listItemsLoading = true),
        switchMap(term => {

          var search = new ContactSearchModal();
          search.searchTerm = term;

          var contacts = this.myFileApiService.getContacts(search).pipe(

            switchMap((contactSearchResult: SearchResultModel<ContactBaseModel>|undefined) =>
              //returns the entire base entity for use with ng-templates on the ng-select  
              of(contactSearchResult?.items.map((contactBaseModel: ContactBaseModel) => contactBaseModel))
            ),

            catchError(() => of([])), // empty list on error

            tap(() => this.listItemsLoading = false)
          );

          return contacts;
        })
      )
    );
  }

  arrayCleared() {
    this.referenceModel = new ContactModel();
    this.referenceModelChange.emit(this.referenceModel);
  }
}
